import { useNavigate } from 'react-router-dom';
import { BACK_ARROW } from '../../assets/icons';
import BreadCrumb from '../../components/BreadCrumb';
import Myrequirements from './Myrequirements/Myrequirements';
import TransferRequests from './TransferRequests/TransferRequests';
import { TabBar, TabItem } from '@wot/components';
import { useTab } from '../../hooks/useTab';

export default function Requirements() {
  const navigate = useNavigate();
  const { activeTab, onTabChange } = useTab('requirements');

  return (
    <div className="w-full min-h-screen flex flex-col">
      <div className="w-full grow bg-[#F5F6F9]">
        <div className="container mx-auto flex-col">
          <div className="lg:flex lg:gap-3 lg:py-10 hidden">
            <div
              className="w-8 h-8 flex items-center justify-center bg-neutralBlue2 rounded-full cursor-pointer drop-shadow-md"
              onClick={() => navigate(-1)}
            >
              <img src={BACK_ARROW} alt="Go Back" />
            </div>
            <BreadCrumb />
          </div>
          <div className="lg:flex lg:flex-col lg:gap-5 hidden">
            <div>
              <h1 className="text-3xl font-semibold">My Requirements</h1>
            </div>
            <TabBar value={activeTab} indicatorColor="bg-primary" onChange={onTabChange} textColor="text-neutralGray1">
              <TabItem label="Requirements" value="requirements" />
              <TabItem label="Transfer Requests" value="transfer-requests" />
            </TabBar>
          </div>
          <div className="lg:hidden flex flex-row bg-white mt-5 p-3 justify-evenly rounded-t-lg drop-shadow-md">
            <TabBar
              value={activeTab}
              indicatorColor="bg-secondary"
              onChange={onTabChange}
              textColor="text-neutralGray1"
            >
              <TabItem label="Requirements" value="requirements" />
              <TabItem label="Transfer Requests" value="transfer-requests" />
            </TabBar>
          </div>
          <div className="w-full">{activeTab === 'requirements' ? <Myrequirements /> : <TransferRequests />}</div>
        </div>
      </div>
    </div>
  );
}
